<ng-container *ngIf="!isCmsShowed">
  <div
    *ngIf="(promo$ | async)?.link || isHomePage"
    class="banner"
    [ngStyle]="{'background-color': (promo$ | async)?.background_color, color: (promo$ | async)?.text_color}"
    [ngClass]="{'banner--home': isHomePage}"
    #banner
  >
    <div
      *ngIf="isHomePage"
      class="vc-body3 banner__item banner__item--baseline"
      #bannerBaseline
      [ngClass]="{
        'banner__item--on': baselineOn && isAnimate,
        'banner__item--off': !baselineOn && isAnimate,
        'banner__item--relative': baselineRelativePosition
      }"
    >
      <h1 class="banner__item__text" i18n="@@HEADER.BANNER.BASELINE">Pre-loved fashion sold by your community</h1>
    </div>
    <vc-ref
      *ngIf="(promo$ | async)?.link"
      [anchor]="true"
      [resource]="(promo$ | async)?.link"
      class="banner__item banner__item--promo"
      #bannerPromo
      [ngClass]="{
        'banner__item--on': !isHomePage || (promoOn && isAnimate),
        'banner__item--off': isHomePage && !promoOn && isAnimate
      }"
    >
      <span class="banner__item__text">{{ (promo$ | async)?.content }}</span>
    </vc-ref>
  </div>
</ng-container>
